import { Component, OnInit } from '@angular/core';

import { Title, Meta } from '@angular/platform-browser';
@Component({
  selector: 'app-aboutus',
  templateUrl: './aboutus.component.html',
  styleUrls: ['./aboutus.component.css']
})
export class AboutusComponent implements OnInit {

  constructor(private titleService: Title, private metaService: Meta) { }

  ngOnInit() {
    this.titleService.setTitle('Over ons l Ticketvoordeel.nl');
    this.metaService.addTags([
      {name: 'keywords', content:'Team Ticketvoordeel.nl, contact ticketvoordeel.nl, bellen ticketvoordeel.nl, email adres ticketvoordeel'},
      {name: 'description', content: 'Uw vertrouwde adres voor het boeken van voordelige vliegtickets. U spaart ook ‘Ticks’  bij Ticketvoordeel.nl die u later kunt inwisselen voor extra korting of mooie cadeaus. '},
      {name: 'robots', content: 'index, follow'}
    ]);
  }

}
